require('./accountsBuyAmazonGiftCardError.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const WizardError = require('components/commons/wizardError/wizardError');
//@constants
const { 
    AMAZON_PROMOCIONES_STEP_THREE,
    AMAZON_GIFT_CARD_TIPO_PROCESS
} = require('constants/tagging');
//@utils
const {
    recordProcess
} = require("utilities/tagging");

class AccountsBuyAmazonGiftCardError extends React.Component {

    componentDidMount() {
        const { title } = this.props;
        recordProcess(
            AMAZON_GIFT_CARD_TIPO_PROCESS, 
            "paso 3/error",
            {
                descripcionError: formatText(title),  
                nombrePagina: AMAZON_PROMOCIONES_STEP_THREE
            },
            true
        );
    }

    render() {
        const {
            content,
            handleCancelClick,
            handleRetryClick,
            showCancelButton,
            showHelpText,
            title,
        } = this.props
        const goBackButtonLabel = <FormattedText value="common-retry" format="uppercase" />;
        const mainButton = {
            label: goBackButtonLabel
        };
        const secondaryButton = {
            label: showCancelButton ? <FormattedText value="common-cancel" /> : '',
        };

        const heplText = showHelpText ? (
            <div className="account-buy-amazon-gift-card-error__help-text-content">
                <FormattedText value="amazonGiftCard-helpBoxDescription" />
            </div>
        ) : null

        return (
            <div className="account-buy-amazon-gift-card-error col-xs-9 center-block">
                <WizardError
                    errorMessage={formatText(title)}
                    mainButton={mainButton}
                    secondaryButton={secondaryButton}
                    onMainButtonClick={handleRetryClick}
                    onSecondaryButtonClick={handleCancelClick}
                >
                    <div className="account-buy-amazon-gift-card-error__error-content">
                        <FormattedText value={content} />
                    </div>
                    {heplText}
                </WizardError>
            </div>
        );
    }
}

AccountsBuyAmazonGiftCardError.propTypes = {
    content: PropTypes.string.isRequired,
    handleCancelClick: PropTypes.func.isRequired,
    handleRetryClick: PropTypes.func.isRequired,
    showCancelButton: PropTypes.bool,
    showHelpText: PropTypes.bool,
    title: PropTypes.string.isRequired,
};

AccountsBuyAmazonGiftCardError.defaultProps = {
    showCancelButton: true,
    showHelpText: true
}

module.exports = AccountsBuyAmazonGiftCardError;
